import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

function DevNotes() {
    const navigate = useNavigate();
    return (
        <>
            <main>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 mt-5 mx-auto">
                            <h5>Why do I need to Allow the Server?</h5>
                            <p>I am currently using a self signed server to host my backend. You need to allow your browser to connect to the server before you are able to use this app.</p>

                            <h5>How do I Allow the Server?</h5>
                            <p>You do nothing basically, just open the link in the Popup of the Home Page, your browser will ask you if you would want to open the webpage, just open it.</p>

                            <h5>Note From Dev</h5>
                            <p>Hey reader! This is a side project of mine that I did to learn a bit about AI and how I can integrate it. If you have any questions or suggestions, drop me an <Link to='mailto:riddheegupta25@gmail.com'>email</Link></p>
                            <div className='mt-5'>
                                <button className='commonWhiteBtn mx-auto' onClick={() => navigate('/')}>
                                    <i className='fa-solid fa-arrow-left'></i>
                                    <span>Back</span>
                                </button>
                            </div>
                        </div>
                        <div className="col-xl-12 mt-5" style={{ minHeight: '300px' }}></div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default DevNotes